import { createClient } from '@supabase/supabase-js';
import { env } from '@/shared/config/env';
import type { Database } from '@/shared/types/database';

/**
 * The single Supabase client instance for the app. No other module should call
 * `createClient` — everything goes through the repository layer, which imports this.
 */
export const supabase = createClient<Database>(env.supabaseUrl, env.supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type AppSupabaseClient = typeof supabase;
